import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useT } from '../context/AppContext';
import './Sidebar.css';
import LogoutModal from './LogoutModal';
import { useApp } from '../context/AppContext';

const Sidebar = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const tr = useT();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [adminOpen, setAdminOpen] = useState(false);
  const { avatar } = useApp();

  useEffect(() => {
    const handler = (e) => {
      if (menuOpen && !e.target.closest('.sidebar-modern') && !e.target.closest('.hamburger-btn'))
        setMenuOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [menuOpen]);

  const handleNav = () => setMenuOpen(false);
  const handleLogoutClick = () => { setMenuOpen(false); setShowLogoutModal(true); };
  const handleCloseModal = () => setShowLogoutModal(false);
  const handleConfirmLogout = () => { setShowLogoutModal(false); logout(); navigate('/'); };

  return (
    <>
      <button className="hamburger-btn" onClick={() => setMenuOpen(v => !v)} aria-label="Menu">
        <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'}`}></i>
      </button>

      {menuOpen && <div className="sidebar-overlay" onClick={() => setMenuOpen(false)} />}

      <aside className={`sidebar-modern ${menuOpen ? 'open' : ''}`}>
        <div className="sidebar-header-modern">
          <div className="logo-container-modern">
            <div className="logo-icon-modern"><i className="fas fa-file-pdf"></i></div>
            <span className="logo-text">Flow Generate</span>
          </div>
          <button className="sidebar-close-btn" onClick={() => setMenuOpen(false)}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <nav className="sidebar-nav-modern">
          <NavLink to="/dashboard" className={({ isActive }) => `nav-item-modern ${isActive ? 'active' : ''}`} onClick={handleNav}>
            <i className="fas fa-home"></i><span>{tr('dashboard')}</span>
          </NavLink>
          <NavLink to="/invoice" className={({ isActive }) => `nav-item-modern ${isActive ? 'active' : ''}`} onClick={handleNav}>
            <i className="fas fa-file-invoice"></i><span>{tr('factures_nav')}</span>
          </NavLink>
          <NavLink to="/cv" className={({ isActive }) => `nav-item-modern ${isActive ? 'active' : ''}`} onClick={handleNav}>
            <i className="fas fa-file-alt"></i><span>{tr('cv_nav')}</span>
          </NavLink>
          <NavLink to="/parametres" className={({ isActive }) => `nav-item-modern ${isActive ? 'active' : ''}`} onClick={handleNav}>
            <i className="fas fa-cog"></i><span>{tr('parametres_nav')}</span>
          </NavLink>

          {user?.role === 'admin' && (
            <div className="nav-admin-section">
              <button
                className={`nav-item-modern nav-admin-toggle ${adminOpen ? 'admin-open' : ''}`}
                onClick={() => setAdminOpen(v => !v)}
              >
                <i className="fas fa-shield-alt"></i>
                <span>{tr('administration')}</span>
                <i className={`fas fa-chevron-${adminOpen ? 'up' : 'down'} nav-admin-chevron`}></i>
              </button>
              {adminOpen && (
                <div className="nav-admin-submenu">
                  <NavLink to="/admin/users" className={({ isActive }) => `nav-item-modern nav-subitem ${isActive ? 'active' : ''}`} onClick={handleNav}>
                    <i className="fas fa-users"></i><span>{tr('utilisateurs')}</span>
                  </NavLink>
                  <NavLink to="/admin/documents" className={({ isActive }) => `nav-item-modern nav-subitem ${isActive ? 'active' : ''}`} onClick={handleNav}>
                    <i className="fas fa-folder-open"></i><span>{tr('documents_nav')}</span>
                  </NavLink>
                  <NavLink to="/admin/stats" className={({ isActive }) => `nav-item-modern nav-subitem ${isActive ? 'active' : ''}`} onClick={handleNav}>
                    <i className="fas fa-chart-bar"></i><span>{tr('statistiques')}</span>
                  </NavLink>
                </div>
              )}
            </div>
          )}
        </nav>

        <div className="sidebar-footer-modern">
          {user && (
            <div className="sidebar-user-badge">
              <div className="sidebar-user-avatar">
                {avatar
                  ? <img src={avatar} alt="avatar" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
                  : user.name?.charAt(0).toUpperCase()
                }
              </div>
              <div className="sidebar-user-info">
                <span className="sidebar-user-name">{user.name}</span>
                <span className={`sidebar-user-role ${user.role === 'admin' ? 'role-admin' : 'role-user'}`}>
                  {user.role === 'admin' ? 'Admin' : 'User'}
                </span>
              </div>
            </div>
          )}
          <button onClick={handleLogoutClick} className="nav-item-modern logout-btn sidebar-logout-btn">
            <i className="fas fa-sign-out-alt"></i>
            <span>{tr('deconnexion')}</span>
          </button>
        </div>
      </aside>

      <LogoutModal isOpen={showLogoutModal} onClose={handleCloseModal} onConfirm={handleConfirmLogout} />
    </>
  );
};

export default Sidebar;